import { TPatientFollowup } from './followup'
import { TLabel } from './locales'
import { TMedicalStaffMember } from './medical-staff-member'
import { TLocation } from './others'
import { TPatient } from './patient'

export enum EMedEventTypes {
  SURGERY = 'surgery',
  CONSULTATION = 'consultation',
}

export type TMedEventFieldName = 'date' | 'UserId' | 'LocationId' | 'convocationDate'

export enum MedEventFieldNameToPatientMedEventFieldName {
  date = 'date',
  UserId = 'UserId',
  LocationId = 'Location',
}

export enum EValidationType {
  REQUIRED = 'REQUIRED',
  RECOMMENDED = 'RECOMMENDED',
  OPTIONAL = 'OPTIONAL',
}

export type TMedEvent = {
  id: number
  type: EMedEventTypes
  intlName?: TLabel
}

export type TMedEventProperty = {
  fieldName: TMedEventFieldName
  label: TLabel
  isRequired: boolean
  withDefaultValue?: boolean
}

export type TConvocationConfig = {
  serviceClosingTime?: string
  serviceOpeningTime?: string
  convocationOffset?: string
}

export type TMedEventUI = {
  MedEvent: { id: number; type: EMedEventTypes }
  validationType: EValidationType
  isRepeatable: boolean
  maxRepetitions?: number
  properties: TMedEventProperty[]
  convocation?: TConvocationConfig
}

export type TPatientMedEventStatus = 'ACTIVE' | 'TO_BE_REVIEWED' | 'REVIEWED' | 'ARCHIVED'

export enum EPatientMedEventOrigin {
  USER = 'USER',
  PATIENT = 'PATIENT',
  WORKFLOW = 'WORKFLOW',
  UNKNOWN = 'UNKNOWN',
}

export enum EConvocationDateSetBy {
  USER = 'USER',
  INTEROP = 'INTEROP',
  CONFIG = 'CONFIG',
}

export type TPatientMedEvent = {
  id: number
  date: string | Date
  convocationDate?: string | Date
  convocationDateSetBy?: EConvocationDateSetBy | null
  comment: string
  participant: string
  done: boolean
  remoteId?: string
  PatientId: number
  Patient?: TPatient
  MedEventId: number
  MedEvent: TMedEvent
  MedicalStaffMemberId?: number
  MedicalStaffMember?: TMedicalStaffMember
  LocationId?: number
  Location?: TLocation
  PatientFollowup?: TPatientFollowup
  PatientFollowupId?: number
  status: TPatientMedEventStatus
  metadata: TPatientMedEventMetadata
  interopMetadata?: TPatientMedEventInteropMetadata | null
  origin: EPatientMedEventOrigin
  createdAt: string
  updatedAt: string
  CreatorId: number
}

export type TPatientMedEventInteropMetadata = {
  visit?: { number?: string; ufMedId?: string }
}

export type TPatientMedEventMetadata = {
  originalLabel?: string
  functionalUnit?: string
  functionalUnitId?: string
}
